var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"text-center"},[_c('p',[_vm._v("Etes-vous sûr de vouloir supprimer ce joueur ?")]),_vm._v(" "),_c('div',{},[_c('button',{staticClass:"ml-3 btn btn-outline-success",on:{"click":_vm.onSubmit}},[_vm._v("OUI")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cc56f2d8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/joueurs/components/Delete.vue
// module id = 610
// module chunks = 0